module.exports = __webpack_public_path__ + "img/stCommonwealth.02b0d266.svg";